import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { RevenueAllocation } from '../../../_models/revenueAllocation';

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const exportRevenueProgressToExcel = (
  allocations: RevenueAllocation[] | null | undefined,
  fileName = 'revenue-progress',
) => {
  const rows = allocations || [];
  if (!rows.length) return;

  const months = rows[0]?.revenueList?.map((r) => ({ year: r.year, month: r.month })) ?? [];

  const data = rows.map((rev) => {
    const base: Record<string, string | number | undefined> = {
      'Revenue type': `${rev.revenueType} (${rev.revenueUnit ?? ''})`.trim(),
    };
    rev.revenueList.forEach((alloc) => {
      if (alloc.year == null || alloc.month == null) return;
      const label = `${MONTH_LABELS[alloc.month - 1]} ${alloc.year}`;
      base[label] = alloc.amount ?? 0;
    });
    void months;
    return base;
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Revenue progress');
  const buf = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
};
